// .c-accordion__panel {
//   max-height: 0;
//   overflow: hidden;
//   transition: max-height 0.4s ease;
// }

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-accordion').forEach((accordion) => {
    accordion.addEventListener('click', (event) => {
      event.preventDefault();

      const panel = document.getElementById(accordion.dataset.target);

      if (panel.parentElement.classList.contains('is-active')) {
        panel.parentElement.classList.remove('is-active');
        panel.style.maxHeight = 0;
      } else {
        panel.parentElement.classList.add('is-active');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });
});
